import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IEmailParams } from './interfaces';

const basePath = '/mail';

/* eslint-disable implicit-arrow-linebreak */

export const sendEmail = (email: IEmailParams): AxiosPromise<IApiResponse<any>> =>
  vaultApi.getInstance().post(`${basePath}`, email);
